var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 0C10.2983 0 0 10.2983 0 23C0 35.7017 10.2983 46 23 46C35.7017 46 46 35.7017 46 23C46 10.2983 35.7017 0 23 0ZM9.58333 36.6869C11.8201 29.9786 18.5284 32.5967 19.6458 28.9627V26.5401C19.1437 26.2698 17.7043 24.4145 17.5528 22.9655C17.1561 22.931 16.5351 22.5381 16.3511 20.9837C16.2533 20.1499 16.6443 19.6803 16.8801 19.5327C16.8801 19.5327 16.2897 18.1873 16.2897 16.8513C16.2917 12.88 18.2582 9.58333 23 9.58333C25.5607 9.58333 26.3542 11.3984 26.3542 11.3984C28.6427 11.3984 29.7083 13.9073 29.7083 16.8494C29.7083 18.3157 29.118 19.5308 29.118 19.5308C29.3557 19.6784 29.7467 20.148 29.6489 20.9817C29.4649 22.5362 28.8439 22.9291 28.4472 22.9636C28.2957 24.4126 26.8582 26.2679 26.3542 26.5382V28.9608C27.4716 32.5968 34.1799 29.9786 36.4167 36.6869C36.4167 36.6869 31.3988 42.1667 23 42.1667C14.5532 42.1667 9.58333 36.6869 9.58333 36.6869Z",
    fill: "#CCCCCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.b889b7b8.svg";
export { ForwardRef as ReactComponent };